import { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import FormControl from "../../components/common/FormControl";
import { toast } from "react-toastify";
import Select from "react-select";
// import { DatePicker } from 'antd';
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AddEditPromoCode = () => {
  const { id } = useParams()
  const [form, setform] = useState({
    name: "",
    discountId: null,
    totalApplied: "",
    startDate: "",
    endDate: ""
  })
  const history = useNavigate()
  const [discounts, setDiscounts] = useState([])

  useEffect(() => {
    getDiscounts()
    if (id) {
      getPromoCodeDetail()
    }
  }, [])

  const getDiscounts = () => {
    ApiClient.get(`discount/listing?status=active`).then(res => {
      if (res.success) {
        setDiscounts(res?.data?.map((item) => {
          return ({ value: item?.id || item?._id, label: item?.name })
        }))
      }
    })
  }

  const getPromoCodeDetail = () => {
    loader(true)
    ApiClient.get(`promocode/detail?id=${id}`).then((res) => {
      if (res.success) {
        setform({
          name: res?.data?.name,
          discountId: res?.data?.discountId?.name ? { value: res?.data?.discountId?.id || res?.data?.discountId?._id, label: res?.data?.discountId?.name } : null,
          totalApplied: res?.data?.totalApplied,
          startDate: res?.data?.startDate ,
          endDate: res?.data?.endDate
        })
      }
      else {
        toast?.error(res?.message)
      }
      loader(false)
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    let method = "post"
    let url = "promocode/add"
    let value = {
      ...form,
      discountId: form?.discountId?.value || "",
      id: id || "",
    }
    if (id) {
      method = "put"
      url = "promocode/update"
    } else {
      delete value.id
    }
    loader(true)
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history(`/promocode`)
      }
      loader(false)
    })
  }

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <Link to={`/promocode`} className="!px-4 py-2 flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3">
                  <i className="fa fa-angle-left text-lg"></i>
                </Link>
              </Tooltip>
              <div>
                <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">{id ? "Edit" : "Add"} Promo Code</h3>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div className="mb-3">
                <FormControl
                  type="text"
                  name="name"
                  label="Name"
                  placeholder="Name"
                  value={form?.name}
                  onChange={(e) => setform({ ...form, name: e })}
                  required
                />
              </div>
              <div className="mb-3">
                <label>Total Applied <span className="text-red-600"> *</span></label>
                <input type="text" value={form?.totalApplied} onChange={e => setform({ ...form, totalApplied: methodModel.isNumber(e) })} maxLength={7} required autoComplete="one-time-code" placeholder="Total Applied" className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2" />
              </div>
              <div className="mb-3">
                <label>Start Date <span className="text-red-600"> *</span></label>
                <div className="w-full">
                  <DatePicker
                    selected={form?.startDate}
                    onChange={(date) => setform((prev) => ({ ...prev, startDate: date }))}
                    className="relative shadow-box bg-white rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 w-full"
                    minDate={new Date()}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <label>End Date <span className="text-red-600"> *</span></label>
                <div className="w-full">
                <DatePicker
                    selected={form?.endDate}
                    onChange={(date) => setform((prev) => ({ ...prev, endDate: date }))}
                    className="relative shadow-box bg-white rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2 w-full"
                    minDate={form?.startDate ? new Date(form?.startDate) : new Date()}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <label>Discount <span className="text-red-600"> *</span></label>
                <Select
                  value={form?.discountId}
                  onChange={e => setform({ ...form, discountId: e })}
                  options={discounts}
                  className="capitalize"
                  placeholder="Select Discount"
                  required
                />
              </div>
            </div>

            <div className="text-right">
              <button type="submit" className="text-white bg-[#F58D18] bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                {id ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditPromoCode;
